<template>
    <div class="d-flex flex-column" style="min-height: 100vh;">
        <Toasts :firebase-uid="auth_uid"/>

        <div class="d-flex px-10 py-4 shadow-md bg-white align-items-center">
            <div class="flex-grow-1">
                <img src="images/ybd_b2b.png" class="h-50px" alt="ybd Logo">
            </div>
            <div class="d-flex flex-row my-3 align-items-center gap-5">
                <div>
                    <h5 class="mb-0">{{ $page.props.user.name }}</h5>
                    <p class="mb-0 text-muted">youbuyda</p>
                </div>
                <div>
                    <UserAvatar :user="$page.props.user"></UserAvatar>
                </div>
                <div>
                    <button class="btn btn-default btn-hover-warning w-40px h-40px"
                            @click="signOut">
                        <i class="fas fa-sign-out-alt"/>
                    </button>
                </div>
            </div>
        </div>

        <div class="d-flex flex-grow-1">
            <div class="d-flex flex-row justify-content-end">
                <PortalTarget name="toolbar" multiple/>
            </div>

            <progress-border :at="progressAt" :total="progressTotal"/>

            <div class="d-flex w-100">
                <div class="col-4 col-xl-3 text-light bg-aside">
                    <div class="text-lg d-flex flex-column gap-10 p-20">
                        <div v-if="currentStep !== 'main'" @click="backToMainSetup"
                             class="cursor-pointer font-weight-bold text-2xl mb-10">
                            <i class="fas fa-arrow-circle-left text-white mr-3"></i>
                            {{ __('actions.back_thing', {thing: __('general.overview')}) }}
                        </div>

                        <div>
                            <h1 class="text-white mb-12">{{ aside.title }}</h1>
                            <div v-html="aside.text"></div>
                        </div>
                        <div class="d-none d-md-block pb-5">
                            <progress-card :at="progressAt" :total="progressTotal"/>
                        </div>
                        <div v-if="mandatoryStepsCompleted">
                            <div class="mb-12">{{ __('account-setup.setup_complete') }}</div>
                            <a :href="$route('dashboard')" class="btn btn-primary">{{ __('actions.start_now') }}<i
                                class="fas fa-arrow-circle-right ml-3"></i></a>
                        </div>
                    </div>
                </div>
                <div class="col bg-gray-50">
                    <FlashMessages/>
                    <div class="content d-flex flex-column flex-column-fluid mx-14 my-8">
                        <!-- CONTENT -->
                        <slot/>
                    </div>
                </div>
            </div>
        </div>
        <PageFooter :margin="false"/>
    </div>
</template>

<script>
import Toasts from '../components/Toasts';
import StoreHeader from '../components/Store/StoreHeader.vue';
import {PortalTarget} from 'portal-vue';
import LanguageSelect from '../components/LanguageSelect.vue';
import PageFooter from './Includes/PageFooter.vue';
import FlashMessages from '../components/FlashMessages.vue';
import AccountSetupCard from '../components/AccountSetup/AccountSetupCard';
import ProgressBorder from '../components/AccountSetup/ProgressBorder';
import ProgressCard from '../components/AccountSetup/ProgressCard';
import UserAvatar from '../components/User/UserAvatar';

export default {
    components: {
        UserAvatar,
        ProgressCard,
        ProgressBorder,
        AccountSetupCard,
        FlashMessages,
        PageFooter,
        LanguageSelect,
        StoreHeader,
        Toasts,
        PortalTarget,
    },

    computed: {
        mandatoryStepsCompleted() {
            return this.mainStepProgress.company === true && this.mainStepProgress.subscription === true
        },

        progressTotal() {
            return Object.keys(this.mainStepProgress).length;
        },
    },

    props: {
        auth_uid: String,
        mainStepProgress: Object,
        currentStep: null,
        aside: {
            title: String,
            text: String,
        },
    },

    data() {
        return {
            progressAt: 0,
        };
    },

    mounted() {
        this.progressAt = this.calculateStepsAt();
    },

    methods: {
        backToMainSetup() {
            this.$inertia.get(this.$route('account-setup.show'));
        },

        calculateStepsAt() {
            let n = 0;
            for (let stepKey of Object.values(this.mainStepProgress)) {
                if (stepKey) {
                    n++;
                }
            }
            return n;
        },

        signOut() {
            window.location.href = this.$route('logout');
        }
    },

    watch: {
        mainStepProgress: {
            handler() {
                this.progressAt = this.calculateStepsAt()
            },
            deep: true,
        },
    },
};
</script>
